// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DrrpTagdimensionmgrIconOutlinedSvg from "@fishx/icons-svg/es/asn/DrrpTagdimensionmgrIconOutlined";
import FishxIcon from '../components/FishxIcon';

var DrrpTagdimensionmgrIconOutlined = function DrrpTagdimensionmgrIconOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: DrrpTagdimensionmgrIconOutlinedSvg
  }));
};

DrrpTagdimensionmgrIconOutlined.displayName = 'DrrpTagdimensionmgrIconOutlined';
export default React.forwardRef(DrrpTagdimensionmgrIconOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/DrrpTagdimensionmgrIconOutlined.js
// module id = 2586
// module chunks = 0